import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EfektikaPdfDownloadService } from 'src/app/services/efektika-pdf-download';

@Component({
  selector: 'libero-consult-create-efektika-strategy-modal',
  templateUrl: './consult-create-efektika-strategy-modal.component.html',
  styleUrl: './consult-create-efektika-strategy-modal.component.scss',
  standalone: false
})
export class ConsultCreateEfektikaStrategyModalComponent {
  @Input() public show: boolean | null = null;
  @Output() public continueBtnClick = new EventEmitter<void>();
  @Output() public backBtnClick = new EventEmitter<void>();

  public constructor(
    public efektikaPdfDownloadService: EfektikaPdfDownloadService,
  ) {}

  public onContinueBtnClick(): void {
    this.continueBtnClick.emit();
  }

  public onBackBtnClick(): void {
    this.backBtnClick.emit();
  }

}
